import { apiErrorMessage, extractApiError } from '../../../lib/api';

/**
 * 조직 RBAC API 에러 코드 → 사용자 문구(「역할·선임」 화면 소유).
 *
 * 코드는 응답 봉투 `error.code`(`extractApiError`)로 읽는다 — 서버 계약(rbac 컨트롤러):
 *  - 배정 POST 409 `ROLE_ASSIGNMENT_OWNER_FORBIDDEN`·`ROLE_ASSIGNMENT_SINGLE_HOLDER_TAKEN`·`ROLE_ASSIGNMENT_ALREADY_EXISTS`, 400 `ROLE_ASSIGNMENT_ACCOUNT_REQUIRED`
 *  - 역할 DELETE 409 `ROLE_HAS_HOLDERS`
 * 목록에 없는 코드는 서버가 준 문구(`apiErrorMessage` — 네트워크·알 수 없는 예외면 null)로, 그것도 없으면
 * 호출부의 일반 문구로 떨어진다.
 */
const RBAC_ERROR_MESSAGES: Record<string, string> = {
  ROLE_ASSIGNMENT_OWNER_FORBIDDEN: '소유자 역할은 여기서 배정할 수 없습니다. 멤버 관리에서 역할을 변경하거나 소유자로 초대하세요.',
  ROLE_ASSIGNMENT_SINGLE_HOLDER_TAKEN: '이 직위는 한 명만 맡을 수 있습니다. 기존 보유자를 먼저 해제하세요.',
  ROLE_ASSIGNMENT_ALREADY_EXISTS: '이미 이 역할을 맡고 있는 인원입니다.',
  ROLE_ASSIGNMENT_ACCOUNT_REQUIRED: '이 역할은 계정이 필요합니다. 초대를 보내 가입·수락한 뒤 배정해 주세요.',
  ROLE_HAS_HOLDERS: '이 역할을 맡은 인원이 있어 삭제할 수 없습니다. 배정을 먼저 해제하세요.',
};

export function rbacErrorMessage(error: unknown, fallback: string): string {
  const { code } = extractApiError(error);
  if (code && RBAC_ERROR_MESSAGES[code]) return RBAC_ERROR_MESSAGES[code];
  return apiErrorMessage(error) ?? fallback;
}
